import React, { useEffect, useState } from "react";
import "@/index.css";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Portfolio from "./components/Portfolio";
import Services from "./components/Services";
import Agenda from "./components/Agenda";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickerModal, { useStickerLille } from "./components/StickerModal";
import WinModal, { useGagneParam } from "./components/WinModal";
import { dictionary } from "./i18n";
import { usePageview } from "./utils/analytics";

function App() {
  usePageview();
  const isStickerLille = useStickerLille();
  const isGagne = useGagneParam();
  const [galleryModalOpen, setGalleryModalOpen] = useState(isStickerLille);
  const [blurActive, setBlurActive] = useState(isStickerLille);
  const [winModalOpen, setWinModalOpen] = useState(isGagne);
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("nono.lang") : null;
    return saved || "fr";
  });

  useEffect(() => {
    localStorage.setItem("nono.lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Any filter other than "none" turns the wrapper into a containing block for
  // position:fixed children (lightbox, navs) — so the filter must be fully
  // removed once the sticker modal's fade-out transition has finished.
  useEffect(() => {
    if (galleryModalOpen) {
      setBlurActive(true);
    } else if (blurActive) {
      const timer = setTimeout(() => setBlurActive(false), 1300);
      return () => clearTimeout(timer);
    }
  }, [galleryModalOpen, blurActive]);

  const t = dictionary[lang];

  return (
    <div className="App bg-ink text-bone min-h-screen">
      <div
        data-testid="app-content"
        style={{
          filter: galleryModalOpen ? "blur(10px)" : blurActive ? "blur(0px)" : "none",
          transition: "filter 1.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <Navigation lang={lang} setLang={setLang} t={t} />
        <main>
          <Hero t={t} />
          <Marquee items={t.marquee} />
          <Portfolio t={t} />
          <Services t={t} />
          <Agenda t={t} />
          <About t={t} />
          <Testimonials t={t} />
          <Contact t={t} />
        </main>
        <Footer t={t} />
      </div>
      <StickerModal open={galleryModalOpen} onClose={() => setGalleryModalOpen(false)} />
      <WinModal open={winModalOpen} onClose={() => setWinModalOpen(false)} />
    </div>
  );
}

export default App;
